"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var components_1 = require("components");
var MapStoreToProps = function (store /*, ownProps: any*/) {
    var images = [];
    var buildSession = store.BuildSession.current;
    if (buildSession) {
        var options = buildSession.getAllOptions();
        if (options) {
            images = Array.from(new Set(options.map(function (o) { return o.icon; }).filter(function (o) { return o !== undefined; })));
            images.sort();
        }
    }
    return {
        images: images
    };
};
exports.default = react_redux_1.connect(MapStoreToProps)(components_1.PreloadImages);
//# sourceMappingURL=PreloadItems.js.map